<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Row :gutter="32">
                <Col span="24">
                    <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                        <Description term="编号：">
                            {{detail.sn}}
                        </Description>
                        <Description term="采购信息：">
                            {{detail.buyer_title}}
                        </Description>
                        <Description term="项目名称：">
                            {{detail.project_name}}
                        </Description>
                        <Description term="供应商：">
                            {{detail.company}}
                        </Description>
                    </DescriptionList>
                    <DescriptionList class="show-description-title" title="" :col="4"  layout="vertical">
                        <Description term="状态：">
                            <Badge v-if="detail.status === 1 || detail.status === 2 || detail.status === 3" color="blue" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 5" color="orange" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 7" color="green" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 4 || detail.status === 6" color="red" :text="detail.status_name" />
                            <Badge v-else color="#999999" text="其他" />
                        </Description>
                        <Description term="驳回原因：" v-if="detail.status === 4 || detail.status === 6">
                            {{detail.object_remark}}
                        </Description>
                        <Description term="驳回时间：" v-if="detail.status === 4 || detail.status === 6">
                            {{detail.object_time}}
                        </Description>
                        <Description term="支出类型：">
                            <Tag>{{detail.type_name}}</Tag>
                        </Description>
                        <Description term="申请支出金额：">
                            <Tag color="blue">{{detail.money}}</Tag>
                        </Description>
                        <Description term="支付金额：" v-if="detail.status === 7">
                            <Tag color="green">{{detail.pay_money}}</Tag>
                        </Description>
                        <Description term="支付时间：" v-if="detail.status === 7">
                            {{detail.money}}
                        </Description>
                        <Description term="收款账户：">
                            {{detail.pay_bank_account}}
                        </Description>
                        <Description term="账户实名：">
                            {{detail.pay_bank_real_name}}
                        </Description>
                        <Description term="收款银行：">
                            {{detail.pay_bank_name}}
                        </Description>
                        <Description term="开户地址：">
                            {{detail.pay_bank_address}}
                        </Description>
                        <Description term="申请人：">
                            {{detail.apply_name}}
                        </Description>
                        <Description term="申请时间：">
                            {{detail.apply_time}}
                        </Description>
                        <Description term="审批人：" v-if="detail.status >= 5">
                            {{detail.auditor_name}}
                        </Description>
                        <Description term="审批时间：" v-if="detail.status >= 5">
                            {{detail.auditor_time}}
                        </Description>
                        <Description term="打款人：" v-if="detail.status === 7">
                            {{detail.draw_name}}
                        </Description>
                        <Description term="打款审批时间：" v-if="detail.status === 7">
                            {{detail.draw_time}}
                        </Description>
                    </DescriptionList>
                  <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                  <Description term="采购清单：">
                    <a href="javascript:void(0);" @click="FileDownload(detail.image[0])">下载文件</a>
                  </Description>
<!--                  <Description term="发票信息：" :col="1"  layout="vertical">-->
<!--                    <a href="javascript:void(0);" @click="FileDownload(detail.invoice_image[0])">下载文件</a>-->
<!--                  </Description>-->
                  <Description term="支付凭证：" :col="1"  layout="vertical" v-if="detail.status === 7">
                    <a href="javascript:void(0);" @click="FileDownload(detail.pay_image[0])">下载文件</a>
                  </Description>
                    <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="detail.remark">
                        <Description term="备注信息：">
                            {{detail.remark}}
                        </Description>
                    </DescriptionList>
                  </DescriptionList>

                  <div v-if="detail.is_invoice == 3 || detail.is_invoice == 4">
                        <Divider orientation="left">发票信息</Divider>
                        <DescriptionList v-for="(item,index) in detail.inv_info" :key="index"  class="show-description-title" title="" :col="2"  layout="vertical">
                            <Description term="开票金额：">
                                <Tag color="blue">{{item.inv_money}}</Tag>
                            </Description>
                            <Description term="开票公司：">
                                {{item.company}}
                            </Description>
                            <Description term="绑定金额：">
                                <Tag color="green">{{item.use_inv_money}}</Tag>
                            </Description>
                            <Description term="发票类型：">
                                <Tag>{{item.inv_type_name}}</Tag>
                            </Description>
                            <Description term="申请人：">
                                {{item.apply_name}}
                            </Description>
                            <Description term="申请时间：">
                                {{item.apply_time}}
                            </Description>
                            <Description term="发票：" :col="1"  layout="vertical">
                                <a href="javascript:void(0);" @click="FileDownload(item.invoice_image)">下载文件</a>
                            </Description>
                            <Description term="备注信息：" :col="1" v-if="item.remark">
                                {{item.remark}}
                            </Description>
                        </DescriptionList>
                    </div>
                </Col>
            </Row>

            <!-- 预览图片 -->
            <Modal
                v-model="is_view_box"
                title="预览"
                :width="840"
                :mask-closable="true"
                :footer-hide="true"
                @on-cancel="PhotoViewClose()">
                <div class="flex-image-box">
                    <img :src="view_url" class="flex-image-box-show">
                </div>
            </Modal>
        </div>
    </Drawer>
</template>

<script>

import {getExpendDetail, getExpendSnDetail} from "@/apis/expend";

export default {
    name: 'ExpendShow',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '支出详情',
            isBox : false,
            detail: [],
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : ''
        }
    },
    methods: {
      FileDownload(url){
        let that = this;
        if(url){
          //下载文件
          const fileUrl = that.site_url + url; // 文件的URL地址
          const parts = fileUrl.split('/');
          const fileName = parts[parts.length - 1];
          const link = document.createElement('a');
          link.href = fileUrl;
          link.target = '_blank';
          link.setAttribute('download', fileName);
          link.click();
        }else{
          that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
        }
      },
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },

        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(expend_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getExpendDetail(expend_id).then(e => {
                that.detail = e.data;
            })
        },
        GetSnDetail(sn){
          let that = this;
          that.$store.commit('SET_LOADING' , true);
          getExpendSnDetail(sn).then(e => {
            that.detail = e.data;
          })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(expend_id){
            this.isBox = true;
            if(expend_id){
                this.GetDetail(expend_id);
            }
        },
        showSn(sn){
          this.isBox = true;
          console.log(sn)
          console.log(123123)
          if(sn){
            this.GetSnDetail(sn);
          }
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
